import { Howl } from 'howler';
export class AudioEngine {
    constructor() {
        this.audioClips = new Map();
    }
    addClip(clipName, clipFileNames, howlOptions) {
        let howl = new Howl(Object.assign({ src: clipFileNames }, howlOptions));
        this.audioClips.set(clipName, howl);
    }
    playClip(clipName) {
        let howl = this.audioClips.get(clipName);
        howl === null || howl === void 0 ? void 0 : howl.play();
    }
}
//# sourceMappingURL=AudioEngine.js.map